import theme from 'theme';
import StyledReactTooltip from './StyledReactTooltip';

interface ITooltipProps {
    children: React.ReactNode;
    text: string;
    tooltipId: string; 
}

const Tooltip = ({ children, text, tooltipId }: ITooltipProps) => {
    return (
        <>
            {children}
            <StyledReactTooltip 
                id={tooltipId} 
                place="bottom" 
                backgroundColor={theme.sherpaBlue}
                textColor={theme.white}>
                {text}
            </StyledReactTooltip>
        </>
    );
};
  
export default Tooltip;
